function l(t, u, i) {
  let n = u.pop(), a = u.reduce((e, r) => (e[r] == null && Object.defineProperty(e, r, { value: {}, configurable: !0, writable: !0, enumerable: !0 }), e[r]), t);
  return a[n] = i, t;
}
export {
  l as addToObjectByPath
};
